module.exports = __webpack_public_path__ + "static/Aprikose-568f2b1c568e0869f7e9a26de810aa6e.png";